export default __webpack_public_path__ + "static/media/Ballroll_00298.0b0570a5.png";